import t from "./index216.mjs";
function a(e, i) {
  return t({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, i);
}
export {
  a as default
};
